<template>
  <div class="container mescroll-touch">
    <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
      <div class="vod">
        <video :src="playurl" :poster="CoverUrl" class="video" ref="videoinner" controls playsinline webkit-playsinline
          autoplay></video>
        <div class="title">{{ detail.Title }}</div>
        <div class="sharerow">
          <!-- <div class="consult-icon" @click="changeFavorite">
            <img
              :src="details.IsCollect ? require('@/assets/images/collect_img.png') : require('@/assets/images/no_collect.png')">
            <span>收藏</span>
          </div> -->
          <div class="consult-icon" @click="showSharePanel = true">
            <img class="share-icon" src="@/assets/images/share.png">
            <span>分享</span>
          </div>
        </div>
      </div>
      <div class="space"></div>
      <div class="main">
        <div class="square_tab_scroll" style="border-bottom: 1px solid #ddd;" ref="expertWrapper">
          <div class="square_tab_wrapper">
            <span :class="{ 'active': SubjectTCode == 1 }" @click="clickTab(1)">简介</span>
            <span :class="{ 'active': SubjectTCode == 2 }" @click="clickTab(2)">目录</span>
          </div>
        </div>
        <div v-show="SubjectTCode == 1">
          <div class="zjmain">
            <div class="modetitle" v-if="detail.Experts.length != 0">专家介绍</div>
            <div class="square_tab_scroll" ref="wrapper">
              <div class="square_tab_wrapper">
                <div class="innerteach" @click="openteach(item.Id)" v-for="(item, index) in detail.Experts"
                  :key="index">
                  <div class="teachlogo">
                    <img :src="baseURL + item.HeadUrl" alt="" class="teachtou rud">
                  </div>
                  <div class="teachtext">
                    <div class="teachname">{{ item.Name }}</div>
                    <div class="teachtip">{{ item.Title }}</div>
                    <div class="teachhos">{{ item.Hospitial }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ketimain">
            <div class="modetitle">课程简介</div>
            <div class="kecheninner" v-html="detail.Description"></div>
          </div>
        </div>
        <div v-show="SubjectTCode == 2">
          <div class="muluitem" v-for="(item, index) in list" :key="index" @click="switchvod(item.ArticleCode)">
            <div class="muluitemmain">
              <div class="mulutitle">{{ item.Title }}</div>
              <div class="mulutimerow">
                <div class="mulutime">时长：{{ item.DurationStr }}</div>
                <!-- <div class="mulujindu">进度：81%</div> -->
              </div>
            </div>
            <div class="muluitemlogo">
              <img src="@/assets/images/muluin.png" alt="" class="muluicon" v-if="item.playing == 0">
              <img src="@/assets/images/muluplay.png" alt="" class="muluicon" v-if="item.playing == 1" />
            </div>
          </div>
        </div>
      </div>
    </mescroll-vue>
    <SharePanel :show="showSharePanel" @close="closeSharePanel" />
    <div class="btmtop" v-if="showteachwindow == 1">
      <div class="btmback" @click="showteachwindow = 0"></div>
      <div class="btmmain">
        <img src="@/assets/images/closebtn.png" alt="" class="closebtn" @click="showteachwindow = 0">
        <div class="btmtouxiang">
          <img :src="baseURL + teacherinfo.HeadUrl" alt="" class="teachtou rud">
        </div>
        <div style="text-align: center;">
          <div class="inteachname">{{ teacherinfo.Name }}</div>
          <div class="inteachtip">{{ teacherinfo.Title }}</div>
          <div class="inteachhos">{{ teacherinfo.Hospitial }}</div>
        </div>
        <div class="inneirong">
          <div v-html="teacherinfo.Description"></div>
        </div>
      </div>
    </div>
    <div v-if="gocheck == true" class="check1">
      <div class="checkback"></div>
      <div class="checkkuang">
        <div class="checkicon"><img src="../../assets/images/checkicon.png" alt="" class="con"></div>
        <div class="checktitle">提醒</div>
        <div class="checkinner">感谢关注！本内容仅对专业人士开放，请先完成对应的注册！</div>
        <div class="btrowi">
          <!-- <div class="clo" @click="backlist()">取消</div> -->
          <div class="jum1" @click="gohfh()">去注册</div>
        </div>
      </div>
    </div>

    <div v-if="gocheck1 == true" class="check1">
      <div class="checkback"></div>
      <div class="checkkuang">
        <div class="checkicon"><img src="../../assets/images/checkicon.png" alt="" class="con"></div>
        <div class="checktitle">提醒</div>
        <div class="checkinner">感谢关注!本内容仅对ACMED会员开放，请您登录后验证身份，谢谢!</div>
        <div class="btrowi">
          <!-- <div class="clo" @click="backlist()">取消</div> -->
          <div class="jum1" @click="goacmedzc()">去验证</div>
        </div>
      </div>
    </div>

    <div v-if="gocheck2 == true" class="check1">
      <div class="checkback"></div>
      <div class="checkkuang">
        <div class="checkicon"><img src="../../assets/images/checkicon.png" alt="" class="con"></div>
        <div class="checktitle">提醒</div>
        <div class="checkinner">感谢关注！本内容仅对华肤荟认证用户开放，请您登录后验证身份，谢谢！</div>
        <div class="btrowi">
          <!-- <div class="clo" @click="backlist()">取消</div> -->
          <div class="jum1" @click="goacmedrz()">去验证</div>
        </div>
      </div>
    </div>

    <div v-if="gocheck3 == true" class="check1">
      <div class="checkback"></div>
      <div class="checkkuang">
        <div class="checkicon"><img src="../../assets/images/checkicon.png" alt="" class="con"></div>
        <div class="checktitle">提醒</div>
        <div class="checkinner">感谢关注!本内容仅对特定用户开放，请您输入手机号验证身份后观看，谢谢!</div>
        <div class="checkinput">
          <el-input v-model="phone" class="cheinpt" placeholder="请输入您的手机号"></el-input>
        </div>
        <div class="btrowi">
          <!-- <div class="clo" @click="backlist()">取消</div> -->
          <div class="jum1" @click="upphone()">提交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
import BScroll from 'better-scroll'
import MescrollVue from 'mescroll.js/mescroll.vue'
import SharePanel from '@/components/sharePanel.vue'
export default {
  name: 'program',
  data() {
    return {
      baseURL: process.env.VUE_APP_BASE_URL,
      details: {},
      constab: 1,
      bannerList: [],
      SubjectTCode: 2,
      list: [],
      PageIndex: 0,
      PageSize: 10,
      mescroll: null, // mescroll实例对象
      mescrollDown: {
        use: false,
        isLock: false
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
        callback: this.upCallback, // 上拉回调
        page: {
          num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 100 //每页数据条数,默认10
        },
        noMoreSize: 0,
        toTop: {
          warpId: 'toTop',
          src: './static/image/top_comm_icon@2x.png' // 回到顶部按钮的图片路径,支持网络图
        }
      },
      showSharePanel: false,
      listword: "",
      subList: [],
      showteachwindow: 0,
      detail: [],
      teacherinfo: [],
      startid: "",
      playcode: "",
      playurl: "",
      CoverUrl: '',
      gocheck: false,
      gocheck1: false,
      gocheck2: false,
      gocheck3: false,
      bmdid: "",
      phone: "",
    }
  },
  mixins: [mixin],
  components: {
    MescrollVue,
    SharePanel
  },
  computed: {
    code() {
      return this.$route.query.code;
    },
    tcode() {
      return this.$route.query.tcode;
    },
  },
  mounted() {
    // this.initBScroll();
    this.yanzheng();
    this.getmulu(1, 100);
  },
  created() {
    document.title = "华肤荟";
  },
  methods: {
    yanzheng() {
      let that = this
      this.$axios.get(`/api/api/web/collection/CheckPermission?collectionId=${this.$route.query.id}`).then(res => {
        if (res.Data.CheckPermission == true) {
          that.gochek = false
          that.gochek1 = false
          that.gochek2 = false
          that.gochek3 = false
        } else {
          if (res.Data.AllowHFHRegUser == true) {
            that.gocheck = true
          } else {
            if (res.Data.AllowACMEDUser == true) {
              that.gocheck1 = true
            } else {
              if (res.Data.AllowHFHIdUser == true) {
                that.gocheck2 = true
              } else {
                if (res.Data.AllowWhiteList == true && !this.$route.query.isbmd) {
                  that.gocheck3 = true
                } else {
                  that.gocheck3 = false
                }
              }
            }
          }
        }
      })
    },
    gohfh() {
      // this.gocheck = false;
      // this.gocheck1 = false;
      // this.gocheck2 = false;
      // this.gocheck3 = false;
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      if (userInfo && userInfo.status < 30) {
        this.$router.push({
          path: 'login'
        });
      }
      else if (userInfo && userInfo.status < 40) {
        this.$router.push({
          path: 'compinfo'
        });
      }
    },
    goacmedzc() {
      let that = this;
      // this.gocheck = false;
      // this.gocheck1 = false;
      // this.gocheck2 = false;
      // this.gocheck3 = false;
      this.$axios.get("/api/api/web/Customer/GetMyInfo").then((res) => {
        if (res.Data.ACMEDIdentity) {
          this.$router.push({
            path: "/newenterin"
          });
        } else {
          this.$router.push({
            path: '/acmedonly'
          });
        }
      });
    },
    goacmedrz() {
      // this.gocheck = false;
      // this.gocheck1 = false;
      // this.gocheck2 = false;
      // this.gocheck3 = false;
      this.$axios.get("/api/api/web/Customer/GetMyInfo").then((res) => {
        if (res.Data.HFHIdentity == '' || res.Data.HFHIdentity == null) {
          this.$router.push({
            path: 'renzhenginfo'
          });
        } else if (res.Data.HFHIdentity != '' && res.Data.HFHIdentity != null && res.Data.HFHIdentity.Status == 0) {
          this.$dialog
            .alert({
              title: "提示",
              message: "认证审核中，请耐心等待",
            })
            .then(() => { });
        }
      });
    },
    upphone() {
      let that = this
      this.$axios.post('/api/api/web/collection/CheckWhiteList', {
        CollectionId: this.$route.query.id,
        Mobile: this.phone,
      }).then(res => {
        if (res.Data == false) {
          this.$message({
            showClose: true,
            message: '暂无权限，请稍后再试',
            type: 'error'
          });
        } else {
          that.gocheck3 = false
        }
      })
    },
    clickTab(type) {
      this.SubjectTCode = type;
    },
    // upCallback(page) {
    //   this.getmulu(page.num, page.size);
    //   if (page.num == 1) {
    //     console.log(this.list)
    //   }
    // },
    switchvod(code) {
      // console.log("1")
      let that = this
      that.playcode = code
      that.getvod()
      that.$refs.videoinner.src = that.playurl;
      that.$refs.videoinner.load()
      for (var i = 0; i < that.list.length; i++) {
        if (code == that.list[i].ArticleCode) {
          that.list[i].playing = 1
        } else {
          that.list[i].playing = 0
        }
      }
    },
    getmulu(PageIndex, PageSize) {
      let that = this;
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;
      this.$axios.post('/api/api/web/collection/CollectionIndexList', {
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        CollectionId: this.$route.query.id,
      }).then(res => {
        if (PageIndex === 1) {
          this.list = []
        }
        this.list = this.list.concat(res.Data);
        this.$nextTick(() => {
          this.mescroll.endSuccess(res.Data.length)
        })
        this.getList();
      })
    },
    getList() {
      let that = this;
      this.$axios.get(`/api/api/web/collection/CollectionDetail?collectionId=${this.$route.query.id}`).then(res => {
        this.detail = res.Data
        this.initShare(this.detail.Title, "有心有料有趣有爱");
        this.startid = this.detail.DefaultArticleId
        // console.log(this.startid)
        for (var i = 0; i < that.list.length; i++) {
          if (this.$route.query.aid) {
            if (this.$route.query.aid == that.list[i].ArticleId) {
              that.playcode = that.list[i].ArticleCode
              // console.log(that.playcode)
              that.getvod()
              that.list[i].playing = 1
              console.log(that.list)
            } else {
              that.list[i].playing = 0
            }
          } else {
            if (that.startid == that.list[i].ArticleId) {
              that.playcode = that.list[i].ArticleCode
              // console.log(that.playcode)
              that.getvod()
              that.list[i].playing = 1
              console.log(that.list)
            } else {
              that.list[i].playing = 0
            }
          }
        }
        this.initBScroll();
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '课程点击',
            TCode: 'course',
            Rid: this.$route.query.id,
          })
      })
    },
    initBScroll() {
      this.$nextTick(() => {
        const wrapper = this.$refs.expertWrapper;
        if (!wrapper) return;

        if (this.expertScroll) {
          this.expertScroll.refresh();
          return;
        }

        this.expertScroll = new BScroll(wrapper, {
          scrollX: true,
          scrollY: false,
          click: true, 
          eventPassthrough: 'vertical'
        });
      });
    },
    mescrollInit(mescroll) {
      this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    changeFavorite() {
      this.$axios.get(`/api/api/web/content/CourseCollect?cid=${this.$route.query.id}`).then(res => {
        this.$dialog
          .alert({
            title: "提示",
            message: "收藏成功！",
          })
          .then(() => {
          });
      })
    },
    closeSharePanel() {
      this.showSharePanel = false;
    },
    openteach(id) {
      let that = this;
      that.teacherinfo = []
      that.showteachwindow = 1
      this.$axios.get(`/api/api/web/content/GetExpertDetail?id=${id}`).then(res => {
        that.teacherinfo = res.Data
      })
    },
    closewind() {
      this.showteachwindow = 0
    },
    getvod() {
      let that = this;
      console.log(that.playcode)
      this.$axios.get(`/api/api/web/content/GetArticleDetail?code=${that.playcode}`).then(res => {
        // console.log(res.Data)
        that.playurl = res.Data.VideoUrl;
        that.CoverUrl = res.Data.VideoCover;
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '课程小节点击',
            TCode: 'course_detail',
            Rid: res.Data.Id,
            UpId: this.$route.query.id
          })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  height: 100%;
  background-color: #fff;
  padding: 0;
  box-sizing: border-box;
}

.vod {
  background: #fff;
}

.video {
  width: 100%;
  margin-bottom: .2rem;
}

.title {
  width: 90%;
  padding-bottom: 0.2rem;
  margin: auto;
}

.sharerow {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: flex-end;
  padding: 0 3%;
  padding-bottom: .2rem;
  box-sizing: border-box;
}

.consult-icon {
  align-items: center;
  display: flex;
  margin-left: 0.3rem;
  background: #F6F8F9;
  justify-content: center;
  padding: 0.1rem;

  img {
    width: 27%;
    margin-right: 0.1rem;
  }
}

.square_tab_scroll {
  display: flex;
  flex-wrap: nowrap;
  // overflow: hidden;
  margin-bottom: 8px;
  margin-top: -6px;
  padding: 6px 0;
  width: 100%;

  .square_tab_wrapper {
    white-space: nowrap;
    // width: 100%;
    display: inline-flex;
  }

  span {
    position: relative;
    color: #435361;
    font-size: 16px;
  }


  span:not(:first-of-type) {
    margin-left: 20px;
  }

  .active {
    color: #1D2A5A;
  }

  .active::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -6px;
    transform: translateX(-16px);
    width: 32px;
    height: 3px;
    border-radius: 3px;
    background: #1f2b5b;
  }
}

/* 隐藏水平滚动条 */
.square_tab_scroll::-webkit-scrollbar {
  display: none;
}

.main {
  padding: 0 4%;
  background: #fff;
  margin-top: 0.5rem;
}

.modetitle {
  color: #0C2941;
  font-weight: bold;
  font-size: .5rem;
  padding-top: .2rem;
  padding-bottom: 0.5rem;
}

.innerteach {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #F5F6FA;
  border-radius: 10px;
  padding: 0.3rem;
  min-width: 5rem;
}

.innerteach:not(:last-child) {
  margin-right: 0.3rem;
}

.teachtou {
  width: 100%;
  display: block;
}

.teachlogo {
  margin-right: 2%;
  width: 1.6rem;
  height: 1.6rem;
  overflow: hidden;
  border-radius: 10rem;
}

.teachtext {
  padding-left: 0.1rem;
  box-sizing: border-box;
}

.teachname {
  font-weight: bold;
  font-size: .45rem;
  color: #0C2941;
}

.teachtip {
  color: #435361;
  margin: 0.1rem 0;
  font-weight: bold;
  font-size: .38rem;
}

.teachhos {
  color: #768FA4;
  font-size: .31rem;
}

.kecheninner {
  color: #0C2941;
  width: 100%;
}

/deep/ .kecheninner>p>img {
  width: 100%;
}

/deep/ .kecheninner>p>span>img {
  width: 100%;
}

/deep/ .kecheninner>p>span>span>img {
  width: 100%;
}

/deep/ .kecheninner>p>span>span>span>img {
  width: 100%;
}

/deep/ .kecheninner>p>span>span>span>span>img {
  width: 100%;
}

.kechenimg {
  width: 100%;
  margin: .5rem 0;
}

.space {
  background: #F5F6FA;
  width: 100%;
  height: .3rem;
}

.btmtop {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  .btmback {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }

  // .btmmain{
  //   transform: translateY(100%);
  // }
  .btmmain {
    position: absolute;
    left: 0;
    transform: translateY(0%);
    transition: transform 1s ease-in-out 1s;
    bottom: 0;
    background: #fff;
    z-index: 9999;
    width: 100%;
    height: 80%;
    border-top-left-radius: 0.666667rem;
    border-top-right-radius: 0.666667rem;
    padding-top: 1rem;
    box-sizing: border-box;
    overflow-y: scroll;

    .btmtouxiang {
      width: 2.5rem;
      height: 2.5rem;
      margin: auto;
      overflow: hidden;
      border-radius: 10rem;
    }
  }
}

.rud {
  border-radius: 100px;
}

.inteachname {
  font-weight: bold;
  font-size: .5rem;
  color: #0C2941;
  margin: 0.3rem 0;
}

.inteachtip {
  color: #435361;
  // margin: 0.1rem 0;
  font-weight: bold;
}

.inteachhos {
  color: #768FA4;
  font-size: .33rem;
  margin: 0.3rem 0;
}

.muluitem {
  display: flex;
  flex-direction: row;
  background: #f5f6fa;
  width: 95%;
  margin: 0.5rem auto;
  padding: 0.25rem;
  box-sizing: border-box;
  border-radius: 10px;
  margin-bottom: 0;
}

.muluicon {
  display: block;
  width: 83%;
  margin: 0.5rem auto;
}

.muluitemmain {
  width: 90%;
  box-sizing: border-box;
  padding-right: 5%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.muluitemlogo {
  width: 10%;
}

.mulutimerow {
  display: flex;
  flex-direction: row;
}

.mulutime {
  width: 42%;
  font-size: .33rem;
  color: #697386;
}

.mulujindu {
  width: 42%;
  font-size: .33rem;
  color: #697386;
}

.inneirong {
  width: 90%;
  margin: auto;
  margin-top: 0.5rem;
}

.closebtn {
  position: absolute;
  right: 5%;
  top: 3%;
  width: 7%;
}

.check1 {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 999;

  .checkback {
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
  }

  .checkkuang {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 999999;
    background: #fff;
    width: 90%;
    border-radius: 15px;
    box-sizing: border-box;
    padding: 0.5rem;
    padding-top: 1.3rem;

    .checkicon {
      width: 20%;
      padding: 0.2rem;
      background: #fff;
      border-radius: 10rem;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      top: 0;

      .con {
        display: block;
        width: 100%;
      }
    }

    .checktitle {
      font-size: 0.5rem;
      font-weight: bold;
      text-align: center;
      margin-bottom: 0.5rem;
    }

    .checkinner {
      margin-bottom: 0.5rem;
    }
  }
}

.btrowi {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.clo {
  width: 47%;
  text-align: center;
  border-radius: 10rem;
  border: 1px solid #ddd;
  padding: 0.2rem 0;
  color: #838383;
}

.jum {
  width: 47%;
  text-align: center;
  border-radius: 10rem;
  border: 1px solid #ddd;
  padding: 0.2rem 0;
  color: #fff;
  background-image: linear-gradient(to right, rgb(75, 185, 248), rgb(39, 101, 236));
}

.jum1 {
  width: 100%;
  text-align: center;
  border-radius: 10rem;
  border: 1px solid #ddd;
  padding: 0.2rem 0;
  color: #fff;
  background-image: linear-gradient(to right, rgb(75, 185, 248), rgb(39, 101, 236));
}

.cheinpt {
  margin-bottom: 0.5rem;
}
</style>